import React, { Component } from 'react';
import { Input, Button, Select, Space } from 'antd';
import { useState } from 'react';

const { TextArea } = Input;
const axios = require("axios");


export const Home =  () => {
	const [bin, setBin] = useState("");
	const [result, setResult] = useState("");
	const [loadings, setLoadings] = useState(false);

	const [source, setSource] = useState("");
	const [target, setTarget] = useState("");

	const doTranslate = () => {
		setLoadings(true);
		const encodedParams = new URLSearchParams();
		encodedParams.append("q", bin);
		encodedParams.append("target", target);
		encodedParams.append("source", source);
		
		const options = {
		  method: 'POST',
		  url: 'https://google-translate1.p.rapidapi.com/language/translate/v2',
		  headers: {
			'content-type': 'application/x-www-form-urlencoded',
			// 'Accept-Encoding': 'application/gzip',
			// 'X-RapidAPI-Key': 'a769226a9emshd23270480e4cfbep13ac17jsna36e112b7970',
			'X-RapidAPI-Key': '0ef6e6f981msh781e6dee32a61dbp14d270jsnda064aebc381',
			'X-RapidAPI-Host': 'google-translate1.p.rapidapi.com'
		  },
		  data: encodedParams
		};
		
		axios.request(options).then(function (response) {
			setResult(response.data.data.translations[0].translatedText);
			setLoadings(false);
		}).catch(function (error) {
			setLoadings(false);
			console.error(error);
		});
	}

	const handleChangeSource = (value) => {
		setSource(value);
	};
	const handleChangeTarget = (value) => {
		setTarget(value);
	};

	return(
		<div>
			<div className="flex justify-center items-center gap-500 m-30">
				<Space wrap>
					<Select
						defaultValue="en"
						// value={source}
						style={{ width: 120 }}
						onChange={handleChangeSource}
						options={[
							{ value: 'hi', label: 'Hin' },
							{ value: 'en', label: 'Eng' },
							// { value: 'disabled', label: 'Disabled', disabled: true },
						]}
					/>
				</Space>

				<Space wrap>
					<Select
						defaultValue="hi"
						// value={target}
						style={{ width: 120 }}
						onChange={handleChangeTarget}
						options={[
							{ value: 'hi', label: 'Hin' },
							{ value: 'en', label: 'Eng' },
						]}
					/>
				</Space>
			</div>
			<div className="flex justify-center items-center gap-20 m-30">
				<TextArea 
					rows={4} 
					placeholder="maxLength is 5000" 
					maxLength={5000} 
					value={bin}
					onChange={(e) => setBin(e.target.value)}
				/>
				<Button type="primary" style={{minWidth: 120}} onClick={doTranslate} loading={loadings ? true : false}>
				{
					!loadings && `Eng=>Hn`
				}				
				</Button>
				<TextArea 
					rows={4} 
					placeholder="maxLength is 5000" 
					maxLength={5000} 
					value={result}
				/>
			</div>
		</div>
	);
	
}
